import type { PendingUdeQuery } from 'app/views/boards/panels/ude/form.types';

export const UDE_QUERY_KEY = 'udeQuery';

export function toPendingQuery(stored: unknown): PendingUdeQuery | null {
  const payload = (stored as Record<string, unknown> | null)?.[UDE_QUERY_KEY] as PendingUdeQuery | undefined;

  if (!payload?.query || typeof payload.query !== 'object') {
    return null;
  }

  return { query: payload.query, chart: payload.chart ?? {} };
}

export function toHashPayload(pending: PendingUdeQuery) {
  return { [UDE_QUERY_KEY]: pending };
}
